var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E53C5000-7599-44FD-B826-94E2B6E6D273") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-home",
    transform: "translate(-448, -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-app-menu",
    transform: "translate(447, 18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "burger-icon",
    transform: "translate(1, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,23.0256533 C5.71666667,23.0256533 5.47917333,22.9296533 5.28750667,22.73792 C5.09584,22.5461867 5,22.3085867 5,22.02512 C5,21.7416533 5.09584,21.5041867 5.28750667,21.3128533 C5.47917333,21.1213867 5.71666667,21.0256533 6,21.0256533 L26.6666667,21.0256533 C26.95,21.0256533 27.1874667,21.12152 27.3790667,21.3132533 C27.5708,21.5049867 27.6666667,21.7425867 27.6666667,22.0260533 C27.6666667,22.30952 27.5708,22.5469867 27.3790667,22.7384533 C27.1874667,22.92992 26.95,23.0256533 26.6666667,23.0256533 L6,23.0256533 Z M6,16.51272 C5.71666667,16.51272 5.47917333,16.4168533 5.28750667,16.22512 C5.09584,16.0333867 5,15.7957867 5,15.51232 C5,15.2288533 5.09584,14.9913867 5.28750667,14.8000533 C5.47917333,14.6085867 5.71666667,14.5128533 6,14.5128533 L26.6666667,14.5128533 C26.95,14.5128533 27.1874667,14.60872 27.3790667,14.8004533 C27.5708,14.9921867 27.6666667,15.2297867 27.6666667,15.5132533 C27.6666667,15.79672 27.5708,16.0341867 27.3790667,16.2256533 C27.1874667,16.4169867 26.95,16.51272 26.6666667,16.51272 L6,16.51272 Z M6,9.99996 C5.71666667,9.99996 5.47917333,9.90408 5.28750667,9.71233333 C5.09584,9.5206 5,9.283 5,8.99953333 C5,8.71608 5.09584,8.47864 5.28750667,8.2872 C5.47917333,8.09573333 5.71666667,8 6,8 L26.6666667,8 C26.95,8 27.1874667,8.09586667 27.3790667,8.28762667 C27.5708,8.47938667 27.6666667,8.71698667 27.6666667,9.00042667 C27.6666667,9.28389333 27.5708,9.52134667 27.3790667,9.7128 C27.1874667,9.90424 26.95,9.99996 26.6666667,9.99996 L6,9.99996 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerIcon);
export default __webpack_public_path__ + "static/media/burger-icon.f17953578509aa24aefccd82c0272d46.svg";
export { ForwardRef as ReactComponent };